var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLunchliner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.68 188.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ddcecf;}.cls-2{fill:#c65435;}.cls-3{fill:#3d3d3d;}.cls-4{fill:#4f4f4f;}.cls-5{fill:#f4864d;}.cls-6{fill:#e5744c;}.cls-7{fill:#d86a47;}.cls-8{fill:#f6dcd5;}.cls-9{fill:#f1ab4d;}.cls-10{fill:#fff;}.cls-11{fill:#665423;}.cls-12{fill:#f3eb29;}.cls-13{fill:#59ba49;}.cls-14{fill:#e94443;}.cls-15{fill:#f8d8b7;}.cls-16{fill:#f3e458;}.cls-17{fill:#dca24a;}.cls-18{fill:#d46553;}.cls-19{fill:#e0cedb;}.cls-20{fill:#edc9e0;}.cls-21{fill:#e5a9cd;}.cls-22{fill:#d78bbb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Road"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,188.43c140.82-62.6,187.38-96.59,182.55-113.62C178.84,61.72,145.39,60.47,145,49.37c-.4-10.65,30.8-21.15,69.72-30.25h14.46c-28,7.75-56.44,17.61-55.65,26.29,1.13,12.52,61.53,6,74.81,31.65,8.26,15.94-.39,46.81-64.25,110.75Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Car"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.58,139.3l-17.7-1.24a10.3,10.3,0,0,1,2.63-7.33c4-4,12.31-3.75,15,.69C157.43,134.51,155.93,138.45,155.58,139.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Back_Tire",
    "data-name": "Back Tire"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182,116.58l-11.87-.7a7.84,7.84,0,0,1,3.2-5.11c2.24-1.48,6.14-2.13,8.08.16S182.1,116.37,182,116.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.12,134.53l-6.32.24-2.09,2,4.84.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 142.79,
    cy: 144.92,
    rx: 5.64,
    ry: 10.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.79,155.31h6.26l-2.43-4.68-5,0C142,152.22,142.41,153.76,142.79,155.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 149.12,
    cy: 144.92,
    rx: 5.64,
    ry: 10.39
  })), /*#__PURE__*/React.createElement("g", {
    id: "Front_Tire",
    "data-name": "Front Tire"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178,114.51l-4.16.16L172.44,116l3.18,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 173.8,
    cy: 121.34,
    rx: 3.7,
    ry: 6.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.8,128.16h4.12l-1.59-3.07-3.27,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 177.97,
    cy: 121.34,
    rx: 3.7,
    ry: 6.82
  })), /*#__PURE__*/React.createElement("path", {
    id: "Front",
    className: "cls-5",
    d: "M180.61,104.7,193.9,91.28,162.29,91l-15.91,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Side",
    className: "cls-6",
    d: "M133.91,154.91c4.16-2,5.82-4.46,6.59-6.19,1.83-4.15-.25-7.26,2.44-11.3a7.85,7.85,0,0,1,4.27-3.39,6.64,6.64,0,0,1,6.18,1.26c1.68,1.57.83,3.32,2,3.91,1.59.83,3.73-2.17,11.3-8.33,3.21-2.61,5.69-4.4,5.58-6.86a18.18,18.18,0,0,1-.24-3.34,8.1,8.1,0,0,1,1-4.09,5.46,5.46,0,0,1,3.49-2.76,4.82,4.82,0,0,1,3.72.88c1.12.86,1.21,1.86,2,1.93s1.11-.6,2-1.65c1.14-1.33,2.47-2.49,3.65-3.78.54-.59,2-2.19,3.21-3.46.85-.89,2.08-2.16,3.65-3.66a1,1,0,0,0,.31-.73L195,92.27a1.05,1.05,0,0,0-.36-.79,1,1,0,0,0-.72-.2,1.07,1.07,0,0,0-.55.22c-.33.27-10.81,8.61-13.85,11a1.88,1.88,0,0,1-1.41.57c-2-.31-.93-5.78-3.92-10.19a15.22,15.22,0,0,0-10.93-5.77,20.64,20.64,0,0,0-6.36.87h0a8.32,8.32,0,0,0-.95.47c-.35.21-10.77,7.93-24.9,18.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top",
    className: "cls-5",
    d: "M61.69,106.35,131,107l32.21-19.82H104.8a5,5,0,0,0-1.32.17,4.66,4.66,0,0,0-.74.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Back",
    className: "cls-7",
    d: "M58.52,109.84q-.59,18.78-1.16,37.54a8.83,8.83,0,0,0,8.81,9.1l63,.08a7.5,7.5,0,0,0,7.47-8.27l-4-38.54a3.83,3.83,0,0,0-3.8-3.44l-66.54-.17A3.81,3.81,0,0,0,58.52,109.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.61,111.6h55.56a4,4,0,0,1,4,3.65l1.36,15.16a2,2,0,0,1-2,2.17H64.82a2,2,0,0,1-2-2.1l.8-15.09A4,4,0,0,1,67.61,111.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 84.76,
    y: 144.92,
    width: 15.93,
    height: 7.64,
    rx: 1.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.85,98.4l1,11.37a2,2,0,0,0,3.16,1.46l13.83-9.92a.26.26,0,0,0,.1-.24l-.28-2a8,8,0,0,0-12.48-5.51l-4.44,3.07A2,2,0,0,0,154.85,98.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Chevrons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "First"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 255.32,
    cy: 54.64,
    rx: 29.4,
    ry: 29.32,
    transform: "translate(36.14 196.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M227.59,64.23h55.46q-13.51,31.33-27,62.68"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 255.32,
    cy: 54.64,
    r: 21.96
  }), /*#__PURE__*/React.createElement("g", {
    id: "Burger"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247.86,43h15a5,5,0,0,1,5,5v2.18A.81.81,0,0,1,267,51H243.67a.81.81,0,0,1-.81-.81V48a5,5,0,0,1,5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M243.6,59.87H267a.81.81,0,0,1,.81.81v.76a2,2,0,0,1-2,2h-21a2,2,0,0,1-2-2v-.76a.81.81,0,0,1,.81-.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 243.96,
    y: 56.73,
    width: 22.67,
    height: 3.15,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 244.49,
    y: 55.05,
    width: 21.56,
    height: 1.68,
    rx: 0.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 244.43,
    y: 51.01,
    width: 21.73,
    height: 2.12,
    rx: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 244.49,
    y: 53.14,
    width: 21.56,
    height: 1.92,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 247.7,
    cy: 44.5,
    rx: 1.22,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 250.72,
    cy: 43.98,
    rx: 1.22,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 251.2,
    cy: 45.59,
    rx: 1.22,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 253.86,
    cy: 44.38,
    rx: 1.22,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 256.16,
    cy: 45.59,
    rx: 1.22,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 257.86,
    cy: 43.98,
    rx: 1.22,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 260.14,
    cy: 45.22,
    rx: 1.22,
    ry: 0.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 262.48,
    cy: 44.17,
    rx: 1.22,
    ry: 0.53
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Second"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 140.35,
    cy: 16.39,
    r: 14.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M126.29,21.26h28.12L140.72,53"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 140.35,
    cy: 16.39,
    r: 11.13
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pizza"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M145.17,11.81l-1.44,3.52L143,17.07l-.34.84-.61,1.47-1.29,3.15a.48.48,0,0,1-.7.23.5.5,0,0,1-.19-.23l-.6-1.47h0c-.17-.39-.35-.85-.57-1.37-.56-1.38-1.31-3.21-2.18-5.33-.22-.56-.46-1.14-.71-1.75l-.32-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M136.35,10.16h8a1,1,0,0,1,1,1v.26a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5v-.26A1,1,0,0,1,136.35,10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M137.68,13.35a1.06,1.06,0,0,1-1.11,1h0c-.22-.56-.46-1.14-.71-1.75a1.2,1.2,0,0,1,.74-.25A1.06,1.06,0,0,1,137.68,13.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 140.6,
    cy: 13.53,
    r: 1.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 138.56,
    cy: 15.15,
    rx: 0.88,
    ry: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M143.73,15.33,143,17.07H143a1.1,1.1,0,0,1-1.18-1,1.1,1.1,0,0,1,1.18-1A1.27,1.27,0,0,1,143.73,15.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 140.07,
    cy: 17.22,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M140.94,20.14a1.1,1.1,0,0,1-1.18,1,1.4,1.4,0,0,1-.47-.08h0c-.17-.39-.35-.85-.57-1.37a1.21,1.21,0,0,1,1-.54A1.1,1.1,0,0,1,140.94,20.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M142.68,17.91l-.61,1.47a.83.83,0,0,1-.74-.79.85.85,0,0,1,.88-.81A.89.89,0,0,1,142.68,17.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 143.38,
    cy: 13.16,
    rx: 0.88,
    ry: 0.81
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Third"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 227.03,
    cy: 6.89,
    r: 6.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M220.52,9.14h13L227.2,23.85"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 227.03,
    cy: 6.89,
    r: 5.15
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 226.82,
    y: 3.16,
    width: 0.33,
    height: 3.35,
    rx: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M225.83,9.58h2.36l.3-3.86h-3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 225.26,
    y: 5.13,
    width: 3.45,
    height: 0.61,
    rx: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 227.03,
    cy: 7.13,
    r: 0.69
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunchliner);
export default __webpack_public_path__ + "static/media/lunchliner.60011b0b8e450b44c53c40dec5b406de.svg";
export { ForwardRef as ReactComponent };